<template>
  <section class="fg-will-change _ptxs _pbxs" :class="color">
    <div container>
      <div class="page-title-wrapper">
        <div class="page-title-inner">
          <div class="page-title-left">
            <slot name="pageTitleLeft"></slot>
          </div>
          <div class="page-title-right">
            <slot name="pageTitleRight"></slot>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

  // Duplicate code of organisms/PageTitle.vue

  export default {
    props: {
      color: {
        default: 'leaf',
        type: String
      }
    }
  }
</script>
